import React from "react";
import {
  Card,
  Grid,
  Paper,
  Title,
  MantineProvider,
  Accordion,
  Group,
  Skeleton,
  SimpleGrid,
  ScrollArea,
} from "@mantine/core";

// ---------------- Skeleton Metric Card ----------------
const SkeletonMetricCard: React.FC = () => (
  <Card
    shadow="sm"
    padding="lg"
    radius="md"
    style={{
      backgroundColor: "#fff",
      border: "1px solid #e0e0e0",
      height: "100%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    <Skeleton height={50} width={50} radius="xl" mb="sm" />
    <Skeleton height={18} width="60%" mb="xs" radius="xl" />
    <Skeleton height={30} width="40%" radius="xl" />
  </Card>
);

// ---------------- Skeleton Badge List ----------------
const SkeletonBadgeList: React.FC = () => (
  <Group spacing="xs">
    {Array.from({ length: 3 }).map((_, i) => (
      <Skeleton key={i} height={20} width={60} radius="xl" />
    ))}
  </Group>
);

// ---------------- Skeleton Mastery List ----------------
const SkeletonMasteryList: React.FC = () => (
  <Paper shadow="sm" p="lg" radius="md" withBorder bg="white">
    <Title order={3} mb="md" c="#333">
      Mastery by Topic/Concept
    </Title>
    <Accordion variant="separated">
      {Array.from({ length: 3 }).map((_, i) => (
        <Accordion.Item key={i} value={`skeleton-${i}`}>
          <Accordion.Control>
            <Group className="flex items-center">
              <Skeleton height={14} width={100} />
              <Skeleton height={20} width={40} radius="xl" />
            </Group>
          </Accordion.Control>
          <Accordion.Panel>
            <SimpleGrid cols={3} spacing="md">
              {Array.from({ length: 5 }).map((_, j) => (
                <div key={j}>
                  <Skeleton height={12} width="70%" mb="xs" />
                  <Skeleton height={16} width="40%" radius="sm" />
                </div>
              ))}
            </SimpleGrid>
          </Accordion.Panel>
        </Accordion.Item>
      ))}
    </Accordion>
  </Paper>
);

// ---------------- Skeleton Progress Component ----------------
export const ProgressSkeleton: React.FC = () => {
  return (
    <MantineProvider theme={{ colorScheme: "light" }}>
      <ScrollArea style={{ height: "100vh" }}>
        <Grid
          gutter="md"
          style={{ backgroundColor: "#f5f5f5", padding: "20px" }}
        >
          {/* Row 1 */}
          {Array.from({ length: 4 }).map((_, i) => (
            <Grid.Col key={i} xs={12} sm={6} lg={3}>
              <SkeletonMetricCard />
            </Grid.Col>
          ))}

          {/* Row 2 - Full Width */}
          <Grid.Col span={12}>
            <SkeletonMetricCard />
          </Grid.Col>

          {/* Mastery by Topic */}
          <Grid.Col span={12}>
            <SkeletonMasteryList />
          </Grid.Col>
        </Grid>
      </ScrollArea>
    </MantineProvider>
  );
};
